import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  CardBody,
  Nav, 
  NavItem, 
  NavLink, 
  TabContent,
  TabPane,
  Button
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { RecursiveEditor, PaginationControl, updateAtPath } from '../../../pages/AI/Cases/CaseDetails2';

const SectionModal = ({ show, setShow, selectedRow = {}, setSelectedRow, onSaveClickHandler }) => {
    const { t } = useTranslation();
    const [articleIndex, setArticleIndex] = useState(0);
    const [activeTab, setActiveTab] = useState("section");


    const handleTabChange = (tab) => {
        if (tab === activeTab) return;
        setActiveTab(tab);

        if (tab === "article") {
            setArticleIndex(0);
        }
    }

    const onChangeValue = (path, newVal) => {
      const updated = updateAtPath(selectedRow, path, newVal);
      setSelectedRow(updated);
    };

    useEffect(() => {
        if (show) {
            setActiveTab('section');
            setArticleIndex(0);
        }

    }, [show])

  return (
    <Modal isOpen={show} centered={true} size="lg">
        <ModalBody className="py-3 px-5">
            <CardBody>
                <div className="listjs-table" id="customerList">
                    <Nav tabs style={{ marginBottom: 16 }}>
                        <NavItem>
                            <NavLink
                            className={activeTab === "section" ? "active" : ""}
                            onClick={() => handleTabChange("section")}
                            style={{ cursor: "pointer" }}
                            >
                            {t('Section')}
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                            className={activeTab === "article" ? "active" : ""}
                            onClick={() => handleTabChange("article")}
                            style={{ cursor: "pointer" }}
                            >
                            {t('Article')}
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="section">
                            <div className="my-3 fs-15">
                                <h4>{t('Sections')}</h4>
                                { Object.keys(selectedRow?.Sections || {}).map((key, index) => {
                                    return (
                                        <div className="mt-3" key={index}>
                                            <RecursiveEditor
                                                name={key}
                                                value={selectedRow?.Sections[key]}
                                                path={["Sections", key]}
                                                onChange={onChangeValue} 
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </TabPane>
                    </TabContent>
                
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="article">
                            <div className="my-3 fs-15">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h4>{t('Articles')}</h4>

                                    <div>
                                        <Button
                                        size="sm"
                                        color="secondary"
                                        outline
                                        onClick={() => {
                                            // add new blank paragraph
                                            const newArticleRange = {
                                                ...(selectedRow.ArticleRange),
                                                articleRanges: [
                                                    ...(selectedRow?.ArticleRange?.articleRanges || []),
                                                    {
                                                        type: "",
                                                        end_page: "",
                                                        start_page: "",
                                                        article_number: "",
                                                        heading_text_exact: ""
                                                    }
                                                ]
                                            };
                                            onChangeValue(["ArticleRange"], newArticleRange);
                                            setArticleIndex((selectedRow?.ArticleRange?.articleRanges || []).length)
                                        }}>
                                        {t('Add')}
                                        </Button>
                                    </div>
                                </div>

                                { selectedRow.ArticleRange ? <>
                                    <div className="mt-3">
                                        <RecursiveEditor
                                            value={selectedRow.ArticleRange?.articleRanges[articleIndex]}
                                            path={["ArticleRange", "articleRanges", articleIndex]}
                                            onChange={onChangeValue}
                                        />
                                    </div>
        
                                    <PaginationControl
                                        total={(selectedRow.ArticleRange?.articleRanges || []).length || 0}
                                        current={articleIndex}
                                        onChange={p => setArticleIndex(p)}
                                    />
                                </> : null

                                }

                                <div>
                                    <Button
                                        size="sm"
                                        color="danger"
                                        outline
                                        onClick={() => {
                                        // remove current paragraph
                                            const obj = {...selectedRow.ArticleRange};
                                            obj.articleRanges?.splice(articleIndex, 1);

                                            onChangeValue(["ArticleRange"], obj);
                                            setArticleIndex(Math.max(0, articleIndex - 1));
                                        }}
                                    >
                                        {t('Delete')}
                                    </Button>
                                </div>

                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </CardBody>


            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                    type="button"
                    className="btn w-sm btn-light"
                    data-bs-dismiss="modal"
                    onClick={() => setShow(false)}
                >
                    {t("Close")}
                </button>
                <button
                    type="button"
                    className="btn w-sm btn-danger d-flex align-items-center"
                    onClick={onSaveClickHandler}
                >
                    {t('Yes, Save it')}
                </button>
            </div>
        </ModalBody>
    </Modal>
  )
}

export default React.memo(SectionModal);